import { all, takeEvery, put, fork } from "redux-saga/effects";
import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions";
import * as API from "../api";
import Helper from "../../helpers/helpers";


export function* loadStateDistrictList() {

  yield takeEvery(actionTypes.LOAD_STATE_DISTRICT_LIST, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("STATEDISTRICTLIST");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadStateDistrictList( action.state, action.district, action.data );
      
      if (response.data.success) {
        yield put(actions.loadStateDistrictListSuccess(response.data.data));
      } else {
        alert(response.data.message);
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
    }
  });
}


export function* loadLanguages() {

  yield takeEvery(actionTypes.LOAD_LANGUAGUES, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("LANGUAGELIST");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadLanguages(action.data);
      
      if (response.data.success) {
        yield put(actions.loadLanguagesSuccess(response.data.data));
      } else {
        alert(response.data.message);
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
    }
  });
}

export function* loadVerificationCode() {

  yield takeEvery(actionTypes.LOAD_VERIFICATION_CODE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("VERIFICATIONCODELIST");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadVerificationCode(action.data);
     
      if (response.data.success && response.data.data) {
        yield put(actions.loadVerificationCodeSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadVerificationCodeFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadVerificationCodeFail());
    }
  });
}


export function* loadOrderType() {

  yield takeEvery(actionTypes.LOAD_ORDER_TYPE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("ORDERTYPELIST");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadOrderType(action.data);
     
      if (response.data.success && response.data.data) {
        yield put(actions.loadOrderTypeSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadOrderTypeFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadOrderTypeFail());
    }
  });
}

export function* loadRecyclingRanking() {

  yield takeEvery(actionTypes.LOAD_RECYCLING_RANKING, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("RECYCLINGRANKING");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadRecyclingRanking(action.data);
      if (response.data.success && response.data.data) {

        yield put(actions.loadRecyclingRankingSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadRecyclingRankingFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadRecyclingRankingFail());
    }
  });
}


export function* setOrderType() {

  yield takeEvery(actionTypes.SET_ORDER_TYPE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("SETORDERTYPE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.setOrderType(action.id, action.data);
     
      if (response.data.success) {
        yield put(actions.setOrderTypeSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.setOrderTypeFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.setOrderTypeFail());
    }
  });
}


export function* removeOrderType() {

  yield takeEvery(actionTypes.REMOVE_ORDER_TYPE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DELORDERTYPE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.removeOrderType(action.id, action.data);
     
      if (response.data.success) {
        yield put(actions.removeOrderTypeSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.removeOrderTypeFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.removeOrderTypeFail());
    }
  });
}


export function* setDistance() {

  yield takeEvery(actionTypes.SET_DISTANCE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("SETDISTANCE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.setDistance(action.id, action.data);
     
      if (response.data.success) {
        yield put(actions.setDistanceSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.setDistanceFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.setDistanceFail());
    }
  });
}


export function* removeDistance() {

  yield takeEvery(actionTypes.REMOVE_DISTANCE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DELDISTANCE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.removeDistance(action.id, action.data);
     
      if (response.data.success) {
        yield put(actions.removeDistanceSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.removeDistanceFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.removeDistanceFail());
    }
  });
}


export function* loadDriverTaskPrice() {

  yield takeEvery(actionTypes.LOAD_DRIVER_TASK_PRICE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DRIVERTASKPRICELIST");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadDriverTaskPrice(action.data);

      if (response.data.success && response.data.data) {
        yield put(actions.loadDriverTaskPriceSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadDriverTaskPriceFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadDriverTaskPriceFail());
    }
  });
}


export function* setDriverTaskPrice() {

  yield takeEvery(actionTypes.SET_DRIVER_TASK_PRICE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("SETDRIVERTASKPRICE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.setDriverTaskPrice(action.data);

      if (response.data.success) {
        yield put(actions.setDriverTaskPriceSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.setDriverTaskPriceFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.setDriverTaskPriceFail());
    }
  });
}


export function* removeDriverTaskPrice() {

  yield takeEvery(actionTypes.REMOVE_DRIVER_TASK_PRICE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DELDRIVERTASKPRICE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.removeDriverTaskPrice(action.id, action.data);

      if (response.data.success) {
        yield put(actions.removeDriverTaskPriceSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.removeDriverTaskPriceFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.removeDriverTaskPriceFail());
    }
  });
}

export function* loadLandfillCostType() {

  yield takeEvery(actionTypes.LOAD_LANDFILL_COST_TYPE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("LANDFILLCOSTTYPELIST");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadLandfillCostType(action.data);
     
      if (response.data.success && response.data.data) {
        yield put(actions.loadLandfillCostTypeSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadLandfillCostTypeFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadLandfillCostTypeFail());
    }
  });
}


export function* loadTimeSlot() {

  yield takeEvery(actionTypes.LOAD_TIME_SLOT, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("TIMESLOTLIST");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadTimeSlot(action.data);
     
      if (response.data.success && response.data.data) {
        yield put(actions.loadTimeSlotSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadTimeSlotFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadTimeSlotFail());
    }
  });
}

export function* loadDistanceList() {

  yield takeEvery(actionTypes.LOAD_DISTANCE_LIST, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DISTANCELIST");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadDistanceList(action.data);
     
      if (response.data.success && response.data.data) {
        yield put(actions.loadDistanceListSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadDistanceListFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadDistanceListFail());
    }
  });
}


export function* loadGroupDevBonusList() {

  yield takeEvery(actionTypes.LOAD_GROUP_DEV_BONUS_LIST, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GROUPDEVBONUSLIST");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadGroupDevBonusList(action.data);
     
      if (response.data.success && response.data.data) {
        yield put(actions.loadGroupDevBonusListSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadGroupDevBonusListFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadGroupDevBonusListFail());
    }
  });
}

export function* loadGroupBonusAverage() {

  yield takeEvery(actionTypes.LOAD_GROUP_BONUS_AVERAGE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GROUPBONUSAVERAGE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadGroupBonusAverage(action.data);

      if (response.data.success && response.data.data) {
        yield put(actions.loadGroupBonusAverageSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadGroupBonusAverageFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadGroupBonusAverageFail());
    }
  });
}


export function* setGroupDevBonus() {

  yield takeEvery(actionTypes.SET_GROUP_DEV_BONUS, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("SETGROUPDEVBONUS");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.setGroupDevBonus(action.data);
     
      if (response.data.success) {
        yield put(actions.setGroupDevBonusSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.setGroupDevBonusFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.setGroupDevBonusFail());
    }
  });
}


export function* updateGroupDevBonus() {

  yield takeEvery(actionTypes.UPDATE_GROUP_DEV_BONUS, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("UPDGROUPDEVBONUS");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.updateGroupDevBonus(action.id, action.data);
     
      if (response.data.success) {
        yield put(actions.updateGroupDevBonusSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.updateGroupDevBonusFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.updateGroupDevBonusFail());
    }
  });
}


export function* removeGroupDevBonus() {

  yield takeEvery(actionTypes.REMOVE_GROUP_DEV_BONUS, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DELGROUPDEVBONUS");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.removeGroupDevBonus(action.id, action.data);
     
      if (response.data.success) {
        yield put(actions.removeGroupDevBonusSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.removeGroupDevBonusFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.removeGroupDevBonusFail());
    }
  });
}


export function* loadLandfillPoint() {

  yield takeEvery(actionTypes.LANDFILL_POINT_LOAD, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("LANDFILLLIST");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadLandfillPoint(action.data);
     
      if (response.data.success && response.data.data) {
        yield put(actions.loadLandfillPointSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadLandfillPointFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadLandfillPointFail());
    }
  });
}

export function* loadLandfillPointDetail() {

  yield takeEvery(actionTypes.LANDFILL_POINT_DETAIL, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("LANDFILLDETAIL");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadLandfillPointDetail(action.id, action.data);
     
      if (response.data.success && response.data.data) {
        yield put(actions.loadLandfillPointDetailSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadLandfillPointDetailFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadLandfillPointDetailFail());
    }
  });
}

export function* addLandfillPoint() {

  yield takeEvery(actionTypes.LANDFILL_POINT_ADD, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("ADDLANDFILL");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.addLandfillPoint(action.data);
     
      if (response.data.success) {
        yield put(actions.addLandfillPointSuccess());
        yield put(actions.toastSuccess(response.data.message));

      } else {
        alert(response.data.message);
        yield put(actions.addLandfillPointFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.addLandfillPointFail());
    }
  });
}

export function* editLandfillPoint() {

  yield takeEvery(actionTypes.LANDFILL_POINT_EDIT, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("EDITLANDFILL");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.editLandfillPoint(action.id, action.data);
     
      if (response.data.success) {
        yield put(actions.editLandfillPointSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.editLandfillPointFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.editLandfillPointFail());
    }
  });
}

export function* publishLandfillPoint() {

  yield takeEvery(actionTypes.LANDFILL_POINT_PUBLISH, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("PUBLISHLANDFILL");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.publishLandfillPoint(action.id, action.data);
     
      if (response.data.success) {
        yield put(actions.publishLandfillPointSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.publishLandfillPointFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.publishLandfillPointFail());
    }
  });
}


export function* removeLandfillPoint() {

  yield takeEvery(actionTypes.LANDFILL_POINT_REMOVE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DELLANDFILL");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.removeLandfillPoint(action.id, action.data);
     
      if (response.data.success) {
        yield put(actions.removeLandfillPointSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.removeLandfillPointFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.removeLandfillPointFail());
    }
  });
}

export function* editRecyclingSalesPrice() {

  yield takeEvery(actionTypes.EDIT_RECYCLING_SALES_PRICE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("EDITRECYCLINGSALESPRICE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.editRecyclingSalesPrice(action.id, action.data);
     
      if (response.data.success) {
        yield put(actions.editRecyclingSalesPriceSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.editRecyclingSalesPriceFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.editRecyclingSalesPriceFail());
    }
  });
}


export function* setLandfillAdjustment() {

  yield takeEvery(actionTypes.LANDFILL_ADJUSTMENT_SET, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("SETLANDFILLADJ");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.setLandfillAdjustment(action.id, action.data);
     
      if (response.data.success) {
        yield put(actions.setLandfillAdjustmentSuccess());
        yield put(actions.toastSuccess(response.data.message));

      } else {
        alert(response.data.message);
        yield put(actions.setLandfillAdjustmentFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.setLandfillAdjustmentFail());
    }
  });
}


export function* removeLandfillAdjustment() {

  yield takeEvery(actionTypes.LANDFILL_ADJUSTMENT_REMOVE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DELLANDFILLADJ");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.removeLandfillAdjustment(action.id, action.data);
     
      if (response.data.success) {
        yield put(actions.removeLandfillAdjustmentSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.removeLandfillAdjustmentFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.removeLandfillAdjustmentFail());
    }
  });
}



export function* loadLandfillAdjustment() {

  yield takeEvery(actionTypes.LANDFILL_ADJUSTMENT_LOAD, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("LANDFILLADJLIST");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadLandfillAdjustment(action.data);
     
      if (response.data.success && response.data.data) {
        yield put(actions.loadLandfillAdjustmentSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadLandfillAdjustmentFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadLandfillAdjustmentFail());
    }
  });
}

export function* loadLandfillAdjustmentDetail() {

  yield takeEvery(actionTypes.LANDFILL_ADJUSTMENT_DETAIL, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("LANDFILLADJDETAIL");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadLandfillAdjustmentDetail(action.id, action.data);
     
      if (response.data.success && response.data.data) {
        yield put(actions.loadLandfillAdjustmentDetailSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadLandfillAdjustmentDetailFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadLandfillAdjustmentDetailFail());
    }
  });
}


export function* loadWeighingPoint() {

  yield takeEvery(actionTypes.WEIGHING_POINT_LOAD, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("WEIGHINGPOINTLIST");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadWeighingPoint(action.data);
     
      if (response.data.success && response.data.data) {
        yield put(actions.loadWeighingPointSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadWeighingPointFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadWeighingPointFail());
    }
  });
}

export function* addWeighingPoint() {

  yield takeEvery(actionTypes.WEIGHING_POINT_ADD, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("ADDWEIGHINGPOINT");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.addWeighingPoint(action.data);
     
      if (response.data.success) {
        yield put(actions.addWeighingPointSuccess());
        yield put(actions.toastSuccess(response.data.message));

      } else {
        alert(response.data.message);
        yield put(actions.addWeighingPointFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.addWeighingPointFail());
    }
  });
}

export function* editWeighingPoint() {

  yield takeEvery(actionTypes.WEIGHING_POINT_EDIT, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("EDITWEIGHINGPOINT");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.editWeighingPoint(action.id, action.data);
     
      if (response.data.success) {
        yield put(actions.editWeighingPointSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.editWeighingPointFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.editWeighingPointFail());
    }
  });
}


export function* removeWeighingPoint() {

  yield takeEvery(actionTypes.WEIGHING_POINT_REMOVE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DELWEIGHINGPOINT");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.removeWeighingPoint(action.id, action.data);
     
      if (response.data.success) {
        yield put(actions.removeWeighingPointSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.removeWeighingPointFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.removeWeighingPointFail());
    }
  });
}


export function* loadSettings() {

  yield takeEvery(actionTypes.SETTING_LOAD, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("SETTINGLOAD");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadSettings(action.data);
     
      if (response.data.success && response.data.data) {
        yield put(actions.loadSettingsSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadSettingsFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadSettingsFail());
    }
  });
}

export function* getSettingValue() {

  yield takeEvery(actionTypes.GET_SETTING_VALUE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GETSETTINGVALUE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.getSettingValue(action.data);
     
      if (response.data.success && response.data.data) {
        yield put(actions.getSettingValueSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.getSettingValueFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.getSettingValueFail());
    }
  });
}

export function* settingUpdate() {

  yield takeEvery(actionTypes.SETTING_UPDATE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("UPDSETTING");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.settingUpdate(action.data);
     
      if (response.data.success) {
        yield put(actions.settingUpdateSuccess());
        yield put(actions.toastSuccess(response.data.message));

      } else {
        alert(response.data.message);
        yield put(actions.settingUpdateFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.settingUpdateFail());
    }
  });
}

export function* loadDrvmSettings() {

  yield takeEvery(actionTypes.DRVM_SETTING_LOAD, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DRVMSETTINGLOAD");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadDrvmSettings(action.data);

      if (response.data.success && response.data.data) {
        yield put(actions.loadDrvmSettingsSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadDrvmSettingsFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadDrvmSettingsFail());
    }
  });
}

export function* drvmSettingUpdate() {

  yield takeEvery(actionTypes.DRVM_SETTING_UPDATE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("UPDDRVMSETTING");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.drvmSettingUpdate(action.data);

      if (response.data.success) {
        yield put(actions.drvmSettingUpdateSuccess());
        yield put(actions.toastSuccess(response.data.message));

      } else {
        alert(response.data.message);
        yield put(actions.drvmSettingUpdateFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.drvmSettingUpdateFail());
    }
  });
}

/** FEEDBACK **/
export function* loadFeedbackSubjectList() {
  
  yield takeEvery(actionTypes.LOAD_FEEDBACK_SUBJECT_LIST, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("FEEDBACKSUBLIST");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadFeedbackSubjectList(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadFeedbackSubjectListSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadFeedbackSubjectListFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadFeedbackSubjectListFail());
    }
  });
}
export function* loadFeedbackList() {
  
  yield takeEvery(actionTypes.LOAD_FEEDBACK_LIST, function*(action) {

    if(!action.data) action.data = {}
    
    let status = (action.data.status) ? action.data.status : ""
    
    let track_no = Helper.generateTrackNo(`FEEBACKLIST${status}`);

    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadFeedbackList(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadFeedbackListSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadFeedbackListFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadFeedbackListFail());
    }
  });
}

export function* loadFeedbackDetail() {
  
  yield takeEvery(actionTypes.LOAD_FEEDBACK_DETAIL, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("FEEDBACKDETAIL");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadFeedbackDetail(action.id, action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadFeedbackDetailSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadFeedbackDetailFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadFeedbackDetailFail());
    }
  });
}


export function* getFeedbackCount() {
  
  yield takeEvery(actionTypes.GET_FEEDBACK_COUNT, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("FEEDBACKCOUNT");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.getFeedbackCount(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.getFeedbackCountSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.getFeedbackCountFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.getFeedbackCountFail());
    }
  });
}


export function* resolveFeedback() {
  yield takeEvery(actionTypes.RESOLVE_FEEDBACK, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("RESOLVEFEEDBACK");
    
    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);
      
    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.resolveFeedback(action.id,action.data);
      if (response.data.success) {
        yield put(actions.resolveFeedbackSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.resolveFeedbackFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.resolveFeedbackFail());
    }
  });
}
/** End FEEDBACK **/

/** MERCHANT REGISTRATION **/
export function* loadMerchantRegistrationList() {
  
  yield takeEvery(actionTypes.LOAD_MERCHANT_REGISTRATION_LIST, function*(action) {

    if(!action.data) action.data = {}
    
    let status = (action.data.status) ? action.data.status : ""
    
    let track_no = Helper.generateTrackNo(`MERREGISTRATIONLIST${status}`);
    
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadMerchantRegistrationList(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadMerchantRegistrationListSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadMerchantRegistrationListFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadMerchantRegistrationListFail());
    }
  });
}

export function* loadMerchantRegistrationDetail() {
  
  yield takeEvery(actionTypes.LOAD_MERCHANT_REGISTRATION_DETAIL, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("MERREGISTRATIONDETAIL");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadMerchantRegistrationDetail(action.id, action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadMerchantRegistrationDetailSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadMerchantRegistrationDetailFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadMerchantRegistrationDetailFail());
    }
  });
}



export function* getMerchantRegistrationCount() {
  
  yield takeEvery(actionTypes.GET_MERCHANT_REGISTRATION_COUNT, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("MERREGISTRATIONCOUNT");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.getMerchantRegistrationCount(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.getMerchantRegistrationCountSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.getMerchantRegistrationCountFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.getMerchantRegistrationCountFail());
    }
  });
}


export function* verifyMerchantRegistration() {
  yield takeEvery(actionTypes.VERIFY_MERCHANT_REGISTRATION, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("VRFMERREGISTRATION");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.verifyMerchantRegistration(action.id, action.data);
      if (response.data.success) {
        yield put(actions.verifyMerchantRegistrationSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.verifyMerchantRegistrationFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.verifyMerchantRegistrationFail());
    }
  });
}

export function* rejectMerchantRegistration() {
  yield takeEvery(actionTypes.REJECT_MERCHANT_REGISTRATION, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("REJECTMERREGISTRATION");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.rejectMerchantRegistration(action.id, action.data);
      if (response.data.success) {
        yield put(actions.rejectMerchantRegistrationSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.rejectMerchantRegistrationFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.rejectMerchantRegistrationFail());
    }
  });
}
/** End MERCHANT REGISTRATION **/

/** Promotion **/
export function* loadPromotionList() {
  
  yield takeEvery(actionTypes.LOAD_PROMOTION_LIST, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("PROMOTIONLIST");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadPromotionList(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadPromotionListSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadPromotionListFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadPromotionListFail());
    }
  });
}

export function* addPromotion() {
  yield takeEvery(actionTypes.ADD_PROMOTION, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("ADDPROMOTIOM");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.addPromotion(action.data);
      if (response.data.success) {
        yield put(actions.addPromotionSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.addPromotionFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.addPromotionFail());
    }
  });
}

export function* editPromotion() {
  yield takeEvery(actionTypes.EDIT_PROMOTION, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("EDITPROMOTION");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.editPromotion(action.id,action.data);
      if (response.data.success) {
        yield put(actions.editPromotionSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.editPromotionFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.editPromotionFail());
    }
  });
}

export function* deletePromotion() {
  yield takeEvery(actionTypes.DELETE_PROMOTION, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DELPROMOTION");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.deletePromotion(action.id, action.data);
      if (response.data.success) {
        yield put(actions.deletePromotionSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.deletePromotionFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.deletePromotionFail());
    }
  });
}
/** End Promotion **/


export function* loadCarbonFootprint() {

  yield takeEvery(actionTypes.LOAD_CARBON_FOOTPRINT, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("CARBONFOOTPRINTLOAD");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadCarbonFootprint(action.data);
     
      if (response.data.success && response.data.data) {
        yield put(actions.loadCarbonFootprintSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadCarbonFootprintFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadCarbonFootprintFail());
    }
  });
}


export function* setCarbonFootprint() {

  yield takeEvery(actionTypes.SET_CARBON_FOOTPRINT, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("SETCARBONFOOTPRINT");
    
    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);
      
    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.setCarbonFootprint(action.key, action.data);
     
      if (response.data.success) {
        yield put(actions.setCarbonFootprintSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.setCarbonFootprintFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.setCarbonFootprintFail());
    }
  });
}

export function* overallImpactLoad() {

  yield takeEvery(actionTypes.LOAD_OVERALL_IMPACT, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("OVERALLIMPACTLOAD");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.overallImpactLoad(action.data);
     
      if (response.data.success && response.data.data) {
        yield put(actions.overallImpactLoadSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.overallImpactLoadFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.overallImpactLoadFail());
    }
  });
}



export function* loadReferralCommission() {

  yield takeEvery(actionTypes.LOAD_REFERRAL_COMMISSION, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("REFERRALCOMMISSIONLOAD");
    action.data.track_no = track_no

    yield put(actions.enableLoading());
    

    try {
      const response = yield API.loadReferralCommission(action.data);
     
      if (response.data.success && response.data.data) {
        yield put(actions.loadReferralCommissionSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadReferralCommissionFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadReferralCommissionFail());
    }
  });
}


export function* setReferralCommission() {

  yield takeEvery(actionTypes.SET_REFERRAL_COMMISSION, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("SETREFERRALCOMMISSION");    
    action.data.track_no = track_no

    yield put(actions.enableLoading());
    
    try {
      const response = yield API.setReferralCommission(action.data);
     
      if (response.data.success) {
        yield put(actions.setReferralCommissionSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.setReferralCommissionFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.setReferralCommissionFail());
    }
  });
}


export function* removeReferralLevel() {

  yield takeEvery(actionTypes.REMOVE_REFERRAL_LEVEL, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("REMOVEREFERRALLEVEL");    
    action.data.track_no = track_no

    yield put(actions.enableLoading());
    
    try {
      const response = yield API.removeReferralLevel(action.id, action.data);
     
      if (response.data.success) {
        yield put(actions.removeReferralLevelSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.removeReferralLevelFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.removeReferralLevelFail());
    }
  });
}



export function* loadInviteFriendSettings() {

  yield takeEvery(actionTypes.LOAD_INVITE_FRIEND_SETTING, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("INVITEFRIENDSETTING");
    action.data.track_no = track_no

    yield put(actions.enableLoading());
    

    try {
      const response = yield API.loadInviteFriendSettings(action.data);
     
      if (response.data.success && response.data.data) {
        yield put(actions.loadInviteFriendSettingsSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadInviteFriendSettingsFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadInviteFriendSettingsFail());
    }
  });
}


export function* setInviteFriendSettings() {

  yield takeEvery(actionTypes.SET_INVITE_FRIEND_SETTING, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("SETINVITEFRIENDSETTING");    
    action.data.track_no = track_no

    yield put(actions.enableLoading());
    
    try {
      const response = yield API.setInviteFriendSettings(action.data);
     
      if (response.data.success) {
        yield put(actions.setInviteFriendSettingsSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.setInviteFriendSettingsFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.setInviteFriendSettingsFail());
    }
  });
}



export function* loadDriverSubscriptionSettings() {

  yield takeEvery(actionTypes.LOAD_DRIVER_SUBSCRIPTION_SETTING, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DRIVERSUBSCRIPTIONSETTING");
    action.data.track_no = track_no

    yield put(actions.enableLoading());
    

    try {
      const response = yield API.loadDriverSubscriptionSettings(action.data);
     
      if (response.data.success && response.data.data) {
        yield put(actions.loadDriverSubscriptionSettingsSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadDriverSubscriptionSettingsFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadDriverSubscriptionSettingsFail());
    }
  });
}


export function* setDriverSubscriptionSettings() {

  yield takeEvery(actionTypes.SET_DRIVER_SUBSCRIPTION_SETTING, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("SETDRIVER_SUBSCRIPTIONSETTING");    
    action.data.track_no = track_no

    yield put(actions.enableLoading());
    
    try {
      const response = yield API.setDriverSubscriptionSettings(action.data);
     
      if (response.data.success) {
        yield put(actions.setDriverSubscriptionSettingsSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.setDriverSubscriptionSettingsFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.setDriverSubscriptionSettingsFail());
    }
  });
}



export function* loadTruckIssue() {

  yield takeEvery(actionTypes.LOAD_TRUCK_ISSUE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("LOADTRUCKISSUE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());
    

    try {
      const response = yield API.loadTruckIssue(action.data);
     
      if (response.data.success && response.data.data) {
        yield put(actions.loadTruckIssueSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadTruckIssueFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadTruckIssueFail());
    }
  });
}


export function* setTruckIssue() {

  yield takeEvery(actionTypes.SET_TRUCK_ISSUE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("SETTRUCKISSUE");    
    action.data.track_no = track_no

    yield put(actions.enableLoading());
    
    try {
      const response = yield API.setTruckIssue(action.id, action.data);
     
      if (response.data.success) {
        yield put(actions.setTruckIssueSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.setTruckIssueFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.setTruckIssueFail());
    }
  });
}


export function* removeTruckIssue() {

  yield takeEvery(actionTypes.REMOVE_TRUCK_ISSUE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("REMOVETRUCKISSUE");    
    action.data.track_no = track_no

    yield put(actions.enableLoading());
    
    try {
      const response = yield API.removeTruckIssue(action.id, action.data);
     
      if (response.data.success) {
        yield put(actions.removeTruckIssueSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.removeTruckIssueFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.removeTruckIssueFail());
    }
  });
}

/* ===== Donation ===== */
export function* getCharitiesCount() {
  
  yield takeEvery(actionTypes.GET_CHARITIES_COUNT, function*(action) {
    
    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("CHARITIESCOUNT");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.getCharitiesCount(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.getCharitiesCountSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.getCharitiesCountFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.getCharitiesCountFail());
    }
  });
}


export function* getCharitiesLoad() {
  
  yield takeEvery(actionTypes.GET_CHARITIES_LOAD, function*(action) {

    if(!action.data) action.data = {}
    
    let status = (action.data.removed) ? "removed" : ""
    let search = (action.data.search) ? action.data.search : ""
    let offset = (action.data.offset) ? action.data.offset : ""
    
    let track_no = Helper.generateTrackNo(`CHARITIESLIST${status}${search}${offset}`);

    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.getCharitiesLoad(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.getCharitiesLoadSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.getCharitiesLoadFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.getCharitiesLoadFail());
    }
  });
}

export function* getCharitiesLoadAll() {
  
  yield takeEvery(actionTypes.GET_CHARITIES_LOAD_ALL, function*(action) {

    if(!action.data) action.data = {}
    
    let track_no = Helper.generateTrackNo(`CHARITIESLISTALL`);

    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.getCharitiesLoad(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.getCharitiesLoadAllSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.getCharitiesLoadAllFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.getCharitiesLoadAllFail());
    }
  });
}


export function* getCharitiesDetail() {
  
  yield takeEvery(actionTypes.GET_CHARITIES_DETAIL, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo(`CHARITIESDETAIL`);

    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.getCharitiesDetail(action.id, action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.getCharitiesDetailSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.getCharitiesDetailFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.getCharitiesDetailFail());
    }
  });
}

export function* createCharities() {

  yield takeEvery(actionTypes.CREATE_CHARITIES, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("CREATECHARITIES");    
    
    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);
      
    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());
    
    try {
      const response = yield API.createCharities(action.data);
     
      if (response.data.success) {
        yield put(actions.createCharitiesSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.createCharitiesFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.createCharitiesFail());
    }
  });
}


export function* updateCharities() {
  yield takeEvery(actionTypes.UPDATE_CHARITIES, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("UPDATECHARITIES");
    
    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);
      
    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.updateCharities(action.id, action.data);
      if (response.data.success) {
        if(response.data.data)
        {
          yield put(actions.updateCharitiesSuccess(response.data.data));

        }else{
          yield put(actions.updateCharitiesSuccess());
          yield put(actions.toastSuccess(response.data.message));

        }
      } else {
        alert(response.data.message);
        yield put(actions.updateCharitiesFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.updateCharitiesFail());
    }
  });
}


export function* charitiesSequenceSet() {

  yield takeEvery(actionTypes.SET_CHARITIES_SEQUENCE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("SETCHARITIESSEQUENCE");    
    action.data.track_no = track_no

    yield put(actions.enableLoading());
    
    try {
      const response = yield API.charitiesSequenceSet(action.data);
     
      if (response.data.success) {
        yield put(actions.charitiesSequenceSetSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.charitiesSequenceSetFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.charitiesSequenceSetFail());
    }
  });
}



export function* removeCharities() {
  yield takeEvery(actionTypes.REMOVE_CHARITIES, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("REMOVECHARITIES");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.removeCharities(action.id, action.data);
      if (response.data.success) {
        if(response.data.data)
        {
          yield put(actions.removeCharitiesSuccess(response.data.data));

        }else{
          yield put(actions.removeCharitiesSuccess());
          yield put(actions.toastSuccess(response.data.message));

        }
      } else {
        alert(response.data.message);
        yield put(actions.removeCharitiesFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.removeCharitiesFail());
    }
  });
}



export function* restoreCharities() {
  yield takeEvery(actionTypes.RESTORE_CHARITIES, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("RESTORECHARITIES");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.restoreCharities(action.id, action.data);
      if (response.data.success) {
        if(response.data.data)
        {
          yield put(actions.restoreCharitiesSuccess(response.data.data));

        }else{
          yield put(actions.restoreCharitiesSuccess());
          yield put(actions.toastSuccess(response.data.message));

        }
      } else {
        alert(response.data.message);
        yield put(actions.restoreCharitiesFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.restoreCharitiesFail());
    }
  });
}

export function* donationRecordList() {
  
  yield takeEvery(actionTypes.GET_DONATION_RECORD, function*(action) {

    if(!action.data) action.data = {}
    
    let status = (action.data.verifyStatus) ? action.data.verifyStatus : ""
    let service_type = (action.data.service_type) ? action.data.service_type : ""
    let search = (action.data.search) ? action.data.search : ""
    
    let track_no = Helper.generateTrackNo(`DONATIONLIST${status}${service_type}${search}`);

    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.donationRecordList(action.data);
      if (response.data.success && response.data.data) {
        
        if(response.data.data.export)
        {
          Helper.loadSecureFile(response.data.data.file_path, file => {
            
            var downloadLink = document.createElement("a");
            downloadLink.href = file;
            downloadLink.download = response.data.data.file_name;
  
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
          });
        }
        
        yield put(actions.donationRecordListSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.donationRecordListFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.donationRecordListFail());
    }
  });
}


export function* donationRecordDetail() {
  
  yield takeEvery(actionTypes.GET_DONATION_DETAIL, function*(action) {
    
    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo(`DONATIONDETAIL`);

    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.donationRecordDetail(action.id, action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.donationRecordDetailSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.donationRecordDetailFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.donationRecordDetailFail());
    }
  });
}
/* ===== Donation ===== */


/* ===== Banner ===== */
export function* getBannerCount() {

  yield takeEvery(actionTypes.GET_BANNER_COUNT, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("BANNERCOUNT");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.getBannerCount(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.getBannerCountSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.getBannerCountFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.getBannerCountFail());
    }
  });
}


export function* getBannerLoad() {

  yield takeEvery(actionTypes.GET_BANNER_LOAD, function*(action) {

    if(!action.data) action.data = {}

    let status = (action.data.removed) ? "removed" : ""
    let search = (action.data.search) ? action.data.search : ""
    let offset = (action.data.offset) ? action.data.offset : ""

    let track_no = Helper.generateTrackNo(`BANNERLIST${status}${search}${offset}`);
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadBannerList(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.getBannerLoadSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.getBannerLoadFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.getBannerLoadFail());
    }
  });
}


export function* createBanner() {

  yield takeEvery(actionTypes.CREATE_BANNER, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("CREATEBANNER");

    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);

    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.createBanner(action.data);
      if (response.data.success) {
        yield put(actions.createBannerSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.createBannerFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.createBannerFail());
    }
  });
}


export function* updateBanner() {

  yield takeEvery(actionTypes.UPDATE_BANNER, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("UPDATEBANNER");

    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);

    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.updateBanner(action.id, action.data);
      if (response.data.success) {
        if(response.data.data) {
          yield put(actions.updateBannerSuccess(response.data.data));
        } else {
          yield put(actions.updateBannerSuccess());
          yield put(actions.toastSuccess(response.data.message));
        }
      } else {
        alert(response.data.message);
        yield put(actions.updateBannerFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.updateBannerFail());
    }
  });
}


export function* bannerSequenceSet() {

  yield takeEvery(actionTypes.SET_BANNER_SEQUENCE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("SETBANNERSEQUENCE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.bannerSequenceSet(action.data);
      if (response.data.success) {
        yield put(actions.bannerSequenceSetSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.bannerSequenceSetFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.bannerSequenceSetFail());
    }
  });
}


export function* removeBanner() {

  yield takeEvery(actionTypes.REMOVE_BANNER, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("REMOVEBANNER");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.removeBanner(action.id, action.data);
      if (response.data.success) {
        if(response.data.data) {
          yield put(actions.removeBannerSuccess(response.data.data));
        } else {
          yield put(actions.removeBannerSuccess());
          yield put(actions.toastSuccess(response.data.message));
        }
      } else {
        alert(response.data.message);
        yield put(actions.removeBannerFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.removeBannerFail());
    }
  });
}


export function* restoreBanner() {

  yield takeEvery(actionTypes.RESTORE_BANNER, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("RESTOREBANNER");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.restoreBanner(action.id, action.data);
      if (response.data.success) {
        if(response.data.data) {
          yield put(actions.restoreBannerSuccess(response.data.data));
        } else {
          yield put(actions.restoreBannerSuccess());
          yield put(actions.toastSuccess(response.data.message));
        }
      } else {
        alert(response.data.message);
        yield put(actions.restoreBannerFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.restoreBannerFail());
    }
  });
}
/* ===== Banner ===== */

/* ===== OpenAI Model ===== */
export function* loadOpenAIModel() {
  yield takeEvery(actionTypes.LOAD_OPENAI_MODEL, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("LOADOPENAIMODEL");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadOpenAIModelList(action.data);
      if (response.data.success) {
        yield put(actions.loadOpenAIModelSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadOpenAIModelFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadOpenAIModelFail());
    }
  });
}

export function* createOpenAIModel() {
  yield takeEvery(actionTypes.CREATE_OPENAI_MODEL, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("CREATEOPENAIMODEL");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.createOpenAIModel(action.data);
      if (response.data.success) {
        yield put(actions.createOpenAIModelSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.createOpenAIModelFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.createOpenAIModelFail());
    }
  });
}

export function* updateOpenAIModel() {
  yield takeEvery(actionTypes.UPDATE_OPENAI_MODEL, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("UPDATEOPENAIMODEL");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.updateOpenAIModel(action.id, action.data);
      if (response.data.success) {
        yield put(actions.updateOpenAIModelSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.updateOpenAIModelFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.updateOpenAIModelFail());
    }
  });
}

export function* removeOpenAIModel() {
  yield takeEvery(actionTypes.REMOVE_OPENAI_MODEL, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("REMOVEOPENAIMODEL");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.removeOpenAIModel(action.id, action.data);
      if (response.data.success) {
        yield put(actions.removeOpenAIModelSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.removeOpenAIModelFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.removeOpenAIModelFail());
    }
  });
}
/* ===== OpenAI Model ===== */

export default function* generalSaga() {
  
  yield all([fork(loadStateDistrictList)]);
  yield all([fork(loadLanguages)]);
  yield all([fork(loadVerificationCode)]);
  yield all([fork(loadRecyclingRanking)]);
  yield all([fork(loadDistanceList)]);
  yield all([fork(loadGroupDevBonusList)]);
  yield all([fork(loadGroupBonusAverage)]);
  yield all([fork(setGroupDevBonus)]);
  yield all([fork(updateGroupDevBonus)]);
  yield all([fork(removeGroupDevBonus)]);
  yield all([fork(loadTimeSlot)]);
  yield all([fork(loadOrderType)]);
  yield all([fork(setOrderType)]);
  yield all([fork(removeOrderType)]);
  yield all([fork(setDistance)]);
  yield all([fork(removeDistance)]);
  yield all([fork(loadDriverTaskPrice)]);
  yield all([fork(setDriverTaskPrice)]);
  yield all([fork(removeDriverTaskPrice)]);
  yield all([fork(loadLandfillCostType)]);
  yield all([fork(loadLandfillPoint)]);
  yield all([fork(loadLandfillPointDetail)]);
  yield all([fork(addLandfillPoint)]);
  yield all([fork(editLandfillPoint)]);
  yield all([fork(publishLandfillPoint)]);
  yield all([fork(removeLandfillPoint)]);
  yield all([fork(editRecyclingSalesPrice)]);
  yield all([fork(loadSettings)]);
  yield all([fork(getSettingValue)]);  
  yield all([fork(settingUpdate)]);
  yield all([fork(loadDrvmSettings)]);
  yield all([fork(drvmSettingUpdate)]);
  yield all([fork(setLandfillAdjustment)]);
  yield all([fork(removeLandfillAdjustment)]);
  yield all([fork(loadLandfillAdjustment)]);
  yield all([fork(loadLandfillAdjustmentDetail)]);
  
  yield all([fork(loadWeighingPoint)]);
  yield all([fork(addWeighingPoint)]);
  yield all([fork(editWeighingPoint)]);
  yield all([fork(removeWeighingPoint)]);

  yield all([fork(loadFeedbackSubjectList)]);
  yield all([fork(loadFeedbackList)]);
  yield all([fork(loadFeedbackDetail)]);
  yield all([fork(getFeedbackCount)]);
  yield all([fork(resolveFeedback)]);
  yield all([fork(loadMerchantRegistrationList)]);
  yield all([fork(loadMerchantRegistrationDetail)]);
  yield all([fork(getMerchantRegistrationCount)]);
  yield all([fork(verifyMerchantRegistration)]);
  yield all([fork(rejectMerchantRegistration)]);
  
  yield all([fork(loadPromotionList)]);
  yield all([fork(addPromotion)]);
  yield all([fork(editPromotion)]);
  yield all([fork(deletePromotion)]);
  
  yield all([fork(loadCarbonFootprint)]);
  yield all([fork(setCarbonFootprint)]);
  yield all([fork(overallImpactLoad)]);

  yield all([fork(loadReferralCommission)]);
  yield all([fork(setReferralCommission)]);  
  yield all([fork(removeReferralLevel)]);
  
  yield all([fork(loadInviteFriendSettings)]);
  yield all([fork(setInviteFriendSettings)]); 
  
  yield all([fork(loadDriverSubscriptionSettings)]);
  yield all([fork(setDriverSubscriptionSettings)]); 

  yield all([fork(loadTruckIssue)]);
  yield all([fork(setTruckIssue)]); 
  yield all([fork(removeTruckIssue)]); 
  
  yield all([fork(getCharitiesCount)]); 
  yield all([fork(getCharitiesLoad)]); 
  yield all([fork(getCharitiesLoadAll)]); 
  yield all([fork(getCharitiesDetail)]); 
  yield all([fork(createCharities)]); 
  yield all([fork(updateCharities)]); 
  yield all([fork(charitiesSequenceSet)]); 
  yield all([fork(removeCharities)]); 
  yield all([fork(restoreCharities)]); 
  yield all([fork(donationRecordList)]); 
  yield all([fork(donationRecordDetail)]); 

  yield all([fork(getBannerCount)]);
  yield all([fork(getBannerLoad)]);
  yield all([fork(createBanner)]);
  yield all([fork(updateBanner)]);
  yield all([fork(bannerSequenceSet)]);
  yield all([fork(removeBanner)]);
  yield all([fork(restoreBanner)]);

  yield all([fork(loadOpenAIModel)]);
  yield all([fork(createOpenAIModel)]);
  yield all([fork(updateOpenAIModel)]);
  yield all([fork(removeOpenAIModel)]);
}
